import {scenariosData} from 'data/scenarios-data';

const getScenarioUrls = (school) => {
	const scenarioQrUrls = [
		{scenarioId: 'game1', qrUrl: scenariosData['game1'].defaultQrUrl},
		{scenarioId: 'game2', qrUrl: scenariosData['game2'].defaultQrUrl},
		{scenarioId: 'game3', qrUrl: scenariosData['game3'].defaultQrUrl},
		{scenarioId: 'game4', qrUrl: scenariosData['game4'].defaultQrUrl},
		{scenarioId: 'game5', qrUrl: scenariosData['game5'].defaultQrUrl}
	];
	
	if (school && school.scenarioQrUrls) {
		scenarioQrUrls.forEach((s) => {
			const scenarioIndex = school.scenarioQrUrls.findIndex((ss) => {
				return ss.scenarioId === s.scenarioId;
			});
			if (scenarioIndex >= 0) {
				scenarioQrUrls[scenarioIndex].qrUrl = school.scenarioQrUrls[scenarioIndex].qrUrl;
			}
		});
	}

	return scenarioQrUrls;
};


export {
	getScenarioUrls
};